function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { useQuery, useQueries } from "./index";
import { request } from "./request";

/** @deprecated Please don't use this.  Using this couples business logic in the our utilities library, consider creating a shared domain library */
export var FeatureFlagKey = /*#__PURE__*/function (FeatureFlagKey) {
  FeatureFlagKey["AgentEditorRewrite"] = "agent_editor_rewrite";
  FeatureFlagKey["ApplicationEarlyAccessMvp"] = "application_early_access_mvp";
  FeatureFlagKey["ApplicationsPlagiarismCheck"] = "applications_plagiarism_check";
  FeatureFlagKey["RejectionReasonRevamp"] = "application_rejection_reason_revamp";
  FeatureFlagKey["RpAccountSettings"] = "rp_account_settings";
  FeatureFlagKey["RpAgentsRewrite"] = "rp_agents_rewrite";
  FeatureFlagKey["RpApplyShopCardEnabled"] = "rp_applyshop_card_enabled";
  FeatureFlagKey["RpKycPilot"] = "rp_kyc_pilot";
  FeatureFlagKey["RpMerchandisingBanners"] = "rp_merchandising_banners";
  FeatureFlagKey["RpMerchPage"] = "rp_merch_page";
  FeatureFlagKey["RpProductMarketingFeatures"] = "rp_product_marketing_features";
  FeatureFlagKey["RpSpotlightCards"] = "rp_spotlight_cards";
  FeatureFlagKey["StudentTCRedirect"] = "student_t_c_redirect";
  FeatureFlagKey["PaymentsCommissionAutoRepayment"] = "payments_commission_auto_repayment";
  FeatureFlagKey["RpPartnerBonusProgram"] = "rp_partner_bonus_program";
  FeatureFlagKey["RpWhatsAppNotification"] = "rp_whatsapp_notification";
  FeatureFlagKey["NewTopNav"] = "new_top_nav";
  FeatureFlagKey["TopNavAllOption"] = "top_nav_all_option";
  return FeatureFlagKey;
}({});

/** @deprecated Please don't use this.  Using this couples business logic in the our utilities library, consider creating a shared domain library */
export var FeatureFlagAttributeKey = /*#__PURE__*/function (FeatureFlagAttributeKey) {
  FeatureFlagAttributeKey["UserId"] = "user_id";
  FeatureFlagAttributeKey["IsUserRPOwner"] = "is_user_rp_owner";
  FeatureFlagAttributeKey["UserCountry"] = "user_country";
  FeatureFlagAttributeKey["UserCity"] = "user_city";
  return FeatureFlagAttributeKey;
}({});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isExpectedResponse(res) {
  return res !== null && _typeof(res) === 'object' && typeof res.enabled === 'boolean';
}
function getFeatureFlag(flagKey, attributes) {
  var attributeParams = Object.entries(attributes !== null && attributes !== void 0 ? attributes : {}).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];
    return "".concat(key, "=").concat(val);
  }).join('&');
  var url = attributeParams ? "/api/v2/feature_flags?feature=".concat(flagKey, "&").concat(attributeParams) : "/api/v2/feature_flags?feature=".concat(flagKey);
  return request(url, {
    // eslint-disable-next-line no-restricted-syntax
    isExpectedResponse: isExpectedResponse
  });
}

/** @deprecated Please don't use this.  please use the useFeatureDecisions hook */
export function useFeatureFlagEnabled(flagKey, options) {
  var _useQuery = useQuery(['featureFlag', flagKey], function () {
      return getFeatureFlag(flagKey, options === null || options === void 0 ? void 0 : options.attributes);
    }, {
      // To avoid surprising our user with UI changes mid-task,
      // use the same value until the page is reloaded.
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false
    }),
    data = _useQuery.data,
    isSuccess = _useQuery.isSuccess,
    isLoading = _useQuery.isLoading;
  if (options !== null && options !== void 0 && options.withLoading) {
    // @ts-expect-error: TypeScript is not smart enough and gives a false negative here. This is the correct return type if `withLoading` is true
    return [isLoading, isSuccess ? data.enabled : null];
  }

  // @ts-expect-error: TypeScript is not smart enough and gives a false negative here. This is the correct return type if `withLoading` is false
  return isSuccess ? data.enabled : null;
}

/** @deprecated Please don't use this.  please use the useFeatureDecisions hook */
export function useFeatureFlagsEnabled(flagKeys, options) {
  var queries = useQueries(flagKeys.map(function (flagKey) {
    return {
      queryKey: ['featureFlag', flagKey],
      queryFn: function queryFn() {
        return getFeatureFlag(flagKey, options === null || options === void 0 ? void 0 : options.attributes);
      }
    };
  }));
  return flagKeys.reduce(function (acc, flagKey, index) {
    //@ts-expect-error ToDo: fix this
    acc[flagKey] = options !== null && options !== void 0 && options.withLoading ?
    //@ts-expect-error ToDo: fix this
    [queries[index].isLoading, queries[index].isSuccess ? queries[index].data.enabled : null] : queries[index].isSuccess ?
    //@ts-expect-error ToDo: fix this
    queries[index].data.enabled : null;
    return acc;
  }, {});
}